import { CheckboxContainer } from "./styled";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { Icons } from "components";

const Checkbox = ({
  theme_standard,
  label,
  linkLabel,
  value,
  onChange,
  onChangeCustom,
  onClickLink,
  errors,
  disabled, // ไม่บังคับ: หน้าตรวจสอบข้อมูล กดไม่ได้ + ดูจางลง
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
    is_disabled: disabled,
  });

  const { t } = useTranslation(["common"]);

  const _onChange = () => {
    if (disabled) return;
    const valueTemp = value ? false : true;
    onChange(valueTemp);
    onChangeCustom && onChangeCustom(valueTemp);
  };

  return (
    <CheckboxContainer className={customClass}>
      <div className="checkbox_container">
        <div onClick={_onChange}>
          {value ? <Icons.Radio isActive /> : <Icons.Radio />}
        </div>
        <div className="checkbox_label">
          <span onClick={_onChange}>{label}</span>
          {linkLabel ? (
            <span className="cb_link" onClick={onClickLink}>
              {linkLabel}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
      {errors && (
        <div className="errors">
          {/* nsSeparator/keySeparator false = ถ้าไม่มีคำแปล จะคืนข้อความเดิม */}
          {t(errors, { ns: "common", nsSeparator: false, keySeparator: false })}
        </div>
      )}
    </CheckboxContainer>
  );
};

export default Checkbox;
